import * as home from '../moudules/home'
import * as good from '../moudules/good'
import * as login from '../moudules/login'
import * as inventory from '../moudules/inventory'
import * as recharge from '../moudules/recharge'
import * as coupon from '../moudules/coupon'

// 默认全部导出
export default {
  home,
  good,
  login,
  inventory,
  recharge,
  coupon
}
